export class ItemsModel{
itCode ='' ;
itTName ='' ;
itGName ='' ;
itAName ='' ;
itClass ='' ;
itUnit ='' ;
iTPurchasis = '0' ;
iTMedical = 0 ;
iTMegor ='' ;
iTStore ='' ;
itGrouping ='' ;
compCode ='1' ;
uaserID ='sa' ;
modifiedDate  = '2021-01-01';
}
